
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gst-number-search/[gstNumberSearch]",
      function () {
        return require("private-next-pages/gst-number-search/[gstNumberSearch].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gst-number-search/[gstNumberSearch]"])
      });
    }
  